const TIMEOUT = 500;
function getOpenQueryChecker() {
  const openQueries = new Set();
  let counter = 0;
  function checkOpenQueries() {
    return new Promise(resolve => {
      const interval = setInterval(() => {
        if (openQueries.size === 0) {
          clearInterval(interval);
          resolve();
        }
      }, TIMEOUT);
    });
  }
  function getRequestId() {
    counter += 1;
    return counter;
  }
  return {
    openQueries,
    checkOpenQueries,
    getRequestId
  };
}
export default getOpenQueryChecker;
//# sourceMappingURL=get-open-query-checker.js.map